import { useEffect } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { t } from "@/i18n-js/instance";
import type { Event } from "@circle-react/types";
import { Form } from "@circle-react-uikit/Form";
import { Typography } from "@circle-react-uikit/Typography";
import { FormItem } from "../../Common/FormItem";
import { useEventsContext } from "../../EditEventContext";
import { ThankYouMessage } from "./ThankYouMessage";

interface NotificationsProps {
  event: Event;
}

export const Notifications = ({ event }: NotificationsProps) => {
  const enableCustomThankYouMessage = useWatch({
    name: "event_setting_attributes.enable_custom_thank_you_message",
    defaultValue:
      event?.event_setting_attributes.enable_custom_thank_you_message || false,
  });

  const { setIsEmailNotificationsEnabled } = useEventsContext();
  const { getValues } = useFormContext();

  const isEmailNotificationsEnabled = getValues(
    "event_setting_attributes.send_email_confirmation",
  );

  useEffect(() => {
    setIsEmailNotificationsEnabled(isEmailNotificationsEnabled);
  }, [isEmailNotificationsEnabled]);

  return (
    <div className="mb-6 md:mb-12">
      <Typography.TitleXl>
        {t("events.edit_modal.notifications.title")}
      </Typography.TitleXl>
      <div className="mt-6 md:mb-3 md:mt-8">
        <Typography.TitleMd>
          {t("events.edit_modal.notifications.publish")}
        </Typography.TitleMd>
      </div>
      <FormItem
        name="event_setting_attributes.send_publish_email"
        tooltipText={t(
          "events.edit_modal.event_setting_attributes.send_publish_email_tooltip",
        )}
        inlineReverse
        className="!pb-0"
      >
        <Form.ToggleSwitch
          variant="small"
          name="event_setting_attributes.send_publish_email"
        />
      </FormItem>
      <div className="mt-6 md:mb-3 md:mt-8">
        <Typography.TitleMd>
          {t("events.edit_modal.notifications.confirmation")}
        </Typography.TitleMd>
      </div>
      <FormItem
        name="event_setting_attributes.send_email_confirmation"
        tooltipText={t(
          "events.edit_modal.event_setting_attributes.send_email_confirmation_tooltip",
        )}
        inlineReverse
        className="!pb-0"
      >
        <Form.ToggleSwitch
          variant="small"
          name="event_setting_attributes.send_email_confirmation"
        />
      </FormItem>
      <FormItem
        name="event_setting_attributes.send_in_app_notification_confirmation"
        tooltipText={t(
          "events.edit_modal.event_setting_attributes.send_in_app_notification_confirmation_tooltip",
        )}
        inlineReverse
        className="!pb-0"
      >
        <Form.ToggleSwitch
          variant="small"
          name="event_setting_attributes.send_in_app_notification_confirmation"
        />
      </FormItem>
      <FormItem
        name="event_setting_attributes.enable_custom_thank_you_message"
        tooltipText={t(
          "events.edit_modal.event_setting_attributes.enable_custom_thank_you_message_tooltip",
        )}
        inlineReverse
        className="!pb-0"
      >
        <Form.ToggleSwitch
          variant="small"
          name="event_setting_attributes.enable_custom_thank_you_message"
        />
      </FormItem>
      {enableCustomThankYouMessage && <ThankYouMessage />}
    </div>
  );
};
